import { OmitPolyfill, TooltipCommonProps } from '../../../common';
import { ButtonProps, ButtonSize } from '../../../Button';
import { TooltipProps } from '../../../Tooltip';
import { ModalTheme } from '../..';
import * as React from 'react';

interface FooterProps {
  className?: string;
  dataHook?: string;
  primaryButtonText?: React.ReactNode;
  primaryButtonProps?: OmitPolyfill<ButtonProps, 'dataHook'>;
  primaryButtonTooltipProps?: TooltipCommonProps & {
    content: TooltipProps['content'];
  };
  primaryButtonOnClick?(): void;
  secondaryButtonText?: React.ReactNode;
  secondaryButtonProps?: OmitPolyfill<ButtonProps, 'dataHook'>;
  secondaryButtonOnClick?(): void;
  actionsSize?: ButtonSize;
  sideActions?: React.ReactNode;
  showFooterDivider?: boolean;
  theme?: ModalTheme;
}

export declare const Footer: React.FunctionComponent<FooterProps>;
